/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing news.
 */
import moment from 'moment';
import newsService from './../../../../services/news';
import campaignService from './../../../../services/campaign';
import newsTransformer from './../../../../transformers/news';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        subject: {
          value: '',
          type: 'text',
        },
        sendAfterDate: {
          value: '',
          type: 'date',
        },
        sendAfterTime: {
          value: '',
          type: 'time',
        },
        sendAfter: {
          value: '',
          type: 'number',
        },
        body: {
          value: '',
          type: 'editor',
        },
        newsCampaignId: {
          value: this.$route.params.id,
          type: 'hidden',
        },
      }),
      campaign: {},
      loading: true,
      sending: false,
    };
  },

  created() {
    Promise.all([
      newsService.show(this.$route.params.newsId),
      campaignService.show(this.$route.params.id),
    ]).then((data) => {
      this.loading = false;
      this.form.assignData(Object.assign(data[0], {
        sendAfterTime: moment(data[0].sendAfterDate).format('HH:mm'),
      }));
      this.form.newsCampaignId = this.$route.params.id;
      this.campaign = data[1];
      if (this.campaign.campaignType === 'Sequence') {
        this.form.hideField('sendAfterDate');
        this.form.hideField('sendAfterTime');
      } else {
        this.form.hideField('sendAfter');
      }
    });
  },

  methods: {
    /**
     * Method to update the news.
     */
    update() {
      this.form.loading = true;
      const data = this.form.data();
      data.sendAfterDate = data.sendAfterDate ?
      moment(`${moment(data.sendAfterDate).format('YYYY-MM-DD')} ${data.sendAfterTime}`).format() :
      '';
      const news = newsTransformer.send(data);
      newsService.update(this.$route.params.newsId, news)
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Send test email.
     */
    test() {
      this.sending = true;
      newsService.test(newsTransformer.send(this.form.data()))
      .then(() => {
        this.sending = false;
        this.$message({
          showClose: true,
          message: this.$t('static.news.create.sendTestSucess'),
          type: 'success',
        });
      }).catch((error) => {
        this.sending = false;
        if (error.response.data) {
          this.form.recordErrors(newsTransformer.fetch(error.response.data));
        }
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/news/edit/edit.js